import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rx-col',
  templateUrl: './rx-col.component.html',
  styleUrls: ['./rx-col.component.scss'],
})
export class RxColComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
